var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResioLogoFaded = function SvgResioLogoFaded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 43.4795V12.0572C0 5.40644 5.42457 0 12.0969 0H24.1204C30.7885 0 36.2174 5.40644 36.2174 12.0572V43.4795H8.04792V14.0467C8.05317 12.447 8.69233 10.9147 9.82534 9.7854C10.9583 8.65611 12.4928 8.022 14.0925 8.02201H22.1231C23.7228 8.022 25.2573 8.65611 26.3903 9.7854C27.5233 10.9147 28.1625 12.447 28.1677 14.0467V35.6984H16.0967V16.0242H20.1198V31.6908H24.1438V14.0467C24.1426 13.512 23.9293 12.9995 23.5505 12.6219C23.1718 12.2444 22.6588 12.0326 22.124 12.033H14.0934C13.5586 12.0326 13.0455 12.2444 12.6668 12.6219C12.2881 12.9995 12.0747 13.512 12.0736 14.0467V39.7094H32.1934V12.0572C32.1934 7.62134 28.571 4.01101 24.1204 4.01101H12.0969C7.64552 4.01101 4.02396 7.62134 4.02396 12.0572V47.7314H36.2174V51.5015H0V43.4795Z",
    fill: "url(#paint0_linear_692_12643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_692_12643",
    x1: 18.1916,
    y1: -4.88401,
    x2: 18.0638,
    y2: 51.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#4773FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#BE5EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F55560"
  })))));
};
export default SvgResioLogoFaded;